import Individuals from "./individuals";
import Dealers from "./agents";
import Stores from "./companies";
import VisaTypes from "./visa-types";
import AddVisaType from "./visa-types/add";
import Verification from "./auth/Verification";
import AddSalariedAgents from "./agents/add";
import ManageDocuments from "./manage-documents";
import AddDocuments from "./manage-documents/add";
import ManageCommission from "./manage-commission";
import AddCommission from "./manage-commission/add";
import ManageApplications from "./applications";
import ApplicationDetails from "./applications/detail";
import ManageLeaves from "./manage-leaves";
import LeaveDetail from "./manage-leaves/detail";
import ManageBranches from "./manage-branches";
import AddBranch from "./manage-branches/add";
import PaymentModes from "./payment-modes";
import PaymentPlans from "./payment-plans";
import Payments from "./payments";
import AddPaymentPlan from "./payment-plans/add";
import AddPaymentMode from "./payment-modes/add";
import PaymentDetail from "./payments/detail";
import BranchDetail from "./manage-branches/detail";
import AddEmployee from "./manage-branches/employees/add";
import CustomerSupport from "./customerSupport";
import ManageCountries from "./manage-countries";
import AddCountries from "./manage-countries/add";
import ManageSalaries from "./manage-salaries";
import AddSalaries from "./manage-salaries/add";
import ManageCitizenship from "./manage-citizenship";
import AddCitizenship from "./manage-citizenship/add";
import PermissionDenied from "./permission-denied";
import CustomerSupportDetail from "./customerSupport/detail";
import ManageOfferLetters from "./offer-letter";
import AddOfferLetter from "./offer-letter/add";
import ManageReligions from "./manage-religions";
import AddReligion from "./manage-religions/add";
import EditApplication from "./applications/edit";
import ProfileDetail from "./ProfileDetail";
import ForgotPassword from "./auth/ForgotPassword";
import Login from "./auth/Login";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import EditProfile from "./editProfile";
import ManageCms from "./manageCms";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import Reports from "./reports";
import Roles from "./userManagement/role";
import UserList from "./userManagement/userList";
import MyProfile from "./myProfile";
import Settings from "./settings";

export default {
  Login,
  Dashboard,
  ForgotPassword,
  ResetPassword,
  Individuals,
  Stores,
  Dealers,
  VisaTypes,
  AddVisaType,
  Verification,
  AddSalariedAgents,
  ManageDocuments,
  AddDocuments,
  ManageCommission,
  PermissionDenied,
  AddCommission,
  ManageApplications,
  ApplicationDetails,
  ManageLeaves,
  LeaveDetail,
  ManageBranches,
  AddBranch,
  PaymentModes,
  PaymentPlans,
  Payments,
  AddPaymentPlan,
  AddPaymentMode,
  PaymentDetail,
  BranchDetail,
  AddEmployee,
  CustomerSupport,
  MyProfile,
  ManageCountries,
  AddCountries,
  ManageSalaries,
  AddSalaries,
  ManageCitizenship,
  AddCitizenship,
  CustomerSupportDetail,
  ManageOfferLetters,
  AddOfferLetter,
  ManageReligions,
  AddReligion,
  EditApplication, 
  Reports,
  Roles,
  UserList,
  ProfileDetail,
  EditProfile,
  ManageNotifications,
  RecievedNotifications,
  ManageCms,
  Settings
};
